export const HOKKU = [
  {
    question: "Хочешь на пляжи Окинавы?",
    text: `Пляж Окинавы: </br>
           Волны, песок и покой – <br>
           Рай самурая. <br>`,
    image: require("../assets/items/1.jpg")
  },
  {
    question: "Хочешь на праздник в Токио?",
    text: `В Токио старом</br>
           Я запущу фейерверк<br>
           В память о дружбе.<br>`,
    image: require("../assets/items/2.jpg")
  },
  {
    question: "Хочешь раскрыть тайны острова Йонагуни?",
    text: `Город подводный</br>
           Скрыт от глаз любопытных<br>
           На Йонагуни.<br>`,
    image: require("../assets/items/3.jpg")
  },
  {
    question: "Хочешь в горы Хонсю?",
    text: `Грозные горы</br>
           Божества подарили<br>
           Древнему Хонсю.<br>`,
    image: require("../assets/items/4.jpg")
  },
  {
    question: "Хочешь караоке в Японии?",
    text: `Мой голос дрожит,</br>
           Смеется красавица – <br>
           Мы в караоке.<br>`,
    image: require("../assets/items/5.jpg")
  },
  {
    question: "Хочешь на праздник в Цувано?",
    text: `Радуют сердце</br>
           Конных лучников игры<br>
            В замке Цувано.<br>`,
    image: require("../assets/items/6.jpg")
  },
  {
    question: "Хочешь на турнир по сумо?",
    text: `Горы столкнулись!</br>
           Кто останется в круге,<br>
           Тот победитель. <br>`,
    image: require("../assets/items/7.jpg")
  },
  {
    question: "Хочешь увидеть праздник Нэбута?",
    text: `Музыка, танец,</br>
           Мимо плывут божества –<br>
           Праздник Нэбута!<br>`,
    image: require("../assets/items/8.jpg")
  },
  {
    question: "Хочешь нырять на рифах Мияко?",
    text: `Остров Мияко,</br>
           Средь рифов коралловых<br>
           Я стану рыбой.<br>`,
    image: require("../assets/items/9.jpg")
  },

  {
    question: "Хочешь наслаждаться японской кухней?",
    text: `Хаката рамэн:</br>
           Лапша, свинина, бульон – <br>
           Путника радость.<br>`,
    image: require("../assets/items/19.jpg")
  },
  {
    question: "Хочешь увидеть храм Кинкакудзи?",
    text: `Деревья, вода,</br>
           Золото павильона – <br>
           Храм Кинкакудзи.<br>`,
    image: require("../assets/items/11.jpg")
  },
  {
    question: "Хочешь отправиться в Саппоро?",
    text: `Дети смеются:</br>
           Снег залепил мне глаза<br>
           В Саппоро зимнем.<br>`,
    image: require("../assets/items/12.jpg")
  },
  {
    question: "Хочешь побывать в театре кабуки?",
    text: `Душу оставил</br>
           Я в театре кабуки,<br>
           Но не жалею. <br>`,
    image: require("../assets/items/13.jpg")
  },

  {
    question: "Хочешь увидеть Фудзияму?",
    text: `Шляпа упала,</br>
           Взгляд отвести не смею.<br>
           Фудзи, ты чудо!<br>`,
    image: require("../assets/items/14.jpg")
  },
  {
    question: "Хочешь побывать в Киото?",
    text: `Поезд в Киото</br>
           Летит, миг обгоняя.<br>
           Время бессильно!<br>`,
    image: require("../assets/items/15.jpg")
  },
  {
    question: "Хочешь увидеть древности Ямато?",
    text: `Замки сёгунов,</br>
           Скромные храмы в горах.<br>
           Тайны былого.<br>`,
    image: require("../assets/items/16.jpg")
  },
  {
    question: "Хочешь побывать на Хоккайдо?",
    text: `Севера гордость,</br>
           Древняя айнов земля - <br>
           Остров Хоккайдо.<br>`,
    image: require("../assets/items/17.jpg")
  },
  {
    question: "Хочешь узнать японские тайны?",
    text: `Женщины ищут</br>
           Дорогу в маленький храм<br>
           Священной Лисы.<br>`,
    image: require("../assets/items/18.jpg")
  },

  {
    question: "Хочешь увидеть Императорский дворец?",
    text: `Мудро построен</br>
           Дворец Императора:<br>
           Скромность и сила!<br>`,
    image: require("../assets/items/19.jpg")
  },
  {
    question: "Хочешь увидеть знаменитые рыбные рынки?",
    text: `В лодке рыбацкой</br>
           Трое: дед, отец и внук.<br>
           Четвертый – тунец.<br>`,
    image: require("../assets/items/20.jpg")
  }
];
